import React, { useContext } from 'react';
import ErrorPages, { SupportLink } from '@pds-react/errorPages';
import '@pds-react/errorPages/dist/imgCalebThePlumber.min.css';
import '@pds-react/errorPages/dist/serverError.min.css';
import { LocalizationContext } from '../app';

const ContactSupport: React.FunctionComponent = () => {
  const localization = useContext(LocalizationContext);

  let title = "We're sorry.";
  let description = 'It looks like something went wrong on our end. We’ll work on getting that fixed.';
  let link = 'Head back to the previous page';

  if (localization?.isInitialized) {
    description = localization.t('contact-support:description');
    title = localization.t('contact-support:title');
    link = localization.t('contact-support:go-back');
  }

  return (
    <ErrorPages body={description} title={title} variant="server">
      <SupportLink href={process.env.PUBLIC_URL}>{link}</SupportLink>
    </ErrorPages>
  );
};

export default ContactSupport;
